export class Room {
    admin : UserDto;
    created_at ?: number;
    members: {};
    room_type : number;
    constructor(admin, created_at, members, room_type) {
      this.admin = admin;
      this.created_at = created_at;
      this.members = members;
      this.room_type = room_type;
    }
}

class UserDto {
  avatar?: string;
  id?: string;
  is_subscribe?: boolean;
  is_verify?: boolean;
  name?: string;
  role?: string;
  source_id?: number;
  type?: string;
 }
export function mapRoom([admin, created_at , members, room_type]) {
    return new Room(admin, created_at, members, room_type);

}
